import React, { useCallback } from 'react';
import { DataFieldToDisplay } from 'src/components-bl/EmailMarketing/constants/data-fields-to-display';
import { MenuItem, SelectType, TypographyVariant } from 'src/components-dummy';
import {
  FieldSelectStyled,
  SelectLabelStyled,
} from './ProductCardSection/ProductCardSection.styles';

interface DataFieldSelectorProps {
  field: DataFieldToDisplay;
  index: number;
  dataFieldsDropdownOptions: DataFieldToDisplay[];
  handleSelectChange: (index: number, item: DataFieldToDisplay) => void;
}

export const DataFieldSelector = ({
  field,
  index,
  dataFieldsDropdownOptions,
  handleSelectChange,
}: DataFieldSelectorProps): JSX.Element => {
  const onChangeSelect = useCallback(
    event => {
      const targetOption = dataFieldsDropdownOptions.find(opt => opt.value === event.target.value);
      if (targetOption) {
        handleSelectChange(index, targetOption);
      }
    },
    [dataFieldsDropdownOptions, handleSelectChange, index]
  );

  return (
    <>
      <SelectLabelStyled variant={TypographyVariant.SmallMedium}>Field source</SelectLabelStyled>
      <FieldSelectStyled
        type={SelectType.Menu}
        value={field.value ?? undefined}
        placeholder='Select field source...'
        onChange={onChangeSelect}
        isError={!field.value}
      >
        {dataFieldsDropdownOptions.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.value}
          </MenuItem>
        ))}
      </FieldSelectStyled>
    </>
  );
};
